export const REQUESTITEMS = 'REQUESTITEMS'
export const DELIVERY_SERVICE_LIST = 'DELIVERY_SERVICE_LIST'
export const DELIVERY_SERVICE_POP = 'DELIVERY_SERVICE_POP'
export const HOTEL_ROLE_PERMISSION = 'HOTEL_ROLE_PERMISSION'
export const HOTEL_DETAILS = 'HOTEL_DETAILS'
export const CLEAR_DATA = 'CLEAR_DATA'
